import { defineComponent as _defineComponent } from 'vue';
import Button from "@/components/ui/button/Button.vue";
import ContextMenu from "@/components/ui/context-menu/ContextMenu.vue";
import { ArrowDownUpIcon, ChevronDownIcon } from "lucide-vue-next";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SortContextMenu',
    props: {
        currentSorts: { type: Array, required: true },
        presetSorts: { type: Array, required: true },
        getFieldLabel: { type: Function, required: true },
        placement: { type: String, required: false, default: "bottom-end" }
    },
    emits: ["sort-selected"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const sortDisplayText = computed(() => {
            if (props.currentSorts.length === 0) {
                return "Sin ordenación";
            }
            return props.currentSorts
                .map((s) => `${props.getFieldLabel(s.field)} (${s.direction === "asc" ? "↑" : "↓"})`)
                .join(", ");
        });
        const sortMenuOptions = computed(() => {
            return [
                ...props.presetSorts.map((preset) => ({
                    label: preset.label,
                    value: preset.label,
                    sorts: preset.sorts,
                })),
            ];
        });
        const handleSelect = (option) => {
            if (option.sorts) {
                emit("sort-selected", option.sorts);
            }
        };
        const __returned__ = { props, emit, sortDisplayText, sortMenuOptions, handleSelect, Button, ContextMenu, get ArrowDownUpIcon() { return ArrowDownUpIcon; }, get ChevronDownIcon() { return ChevronDownIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
